import axios from 'axios';
import router from '../Router/index';

export default {
  namespaced: true,

  state: {
    blanks: [],
    next: false,
    save: false
  },

  getters: {
    getBlanks(state) {
      return state.blanks;
    },
    getBlank(state, index) {
      return state.blanks[index];
    },
    getNextStatus(state) {
      return state.next;
    },
    getSaveStatus(state) {
      return state.save;
    }
  },

  mutations: {
    PUSH_NEW(state, value) {
      state.blanks.push(value);
    },
    UPDATE_OLD(state, value, index) {
      state.blanks[index] = value;
    },
    CLEAR_ALL(state) {
      state.blanks = [];
    },
    SET_NEXT(state, value) {
      state.next = value;
    },
    SET_SAVE(state, value) {
      state.save = value;
    }
  },

  actions: {
    addBlank({ dispatch, commit }, value) {
      commit('PUSH_NEW', value);
    },
    updateNext({ commit }, value) {
      commit('SET_NEXT', value);
    },
    updateSave({ commit }, value) {
      commit('SET_SAVE', value);
    }
  }
};
